"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),t=require("react/jsx-runtime"),i=require("react"),a=require("styled-components"),s=require("@vds-tokens/core"),o=require("@vds/lists"),n=require("@vds/buttons"),d=require("@vds/typography"),l=require("@vds/type-lockups"),p=require("@plans/utilities"),r=require("../tile/index.js");function u(e){return e&&e.__esModule?e:{default:e}}var c=u(a);const m=c.default(r.default).withConfig({displayName:"StyledTile",componentId:"VDS__sc-fyj8f3-0"})``,f=c.default.div.withConfig({displayName:"ContentWrapper",componentId:"VDS__sc-fyj8f3-1"})`
  display: flex;
  flex-direction: column;
  padding: ${s.LayoutTokens.space["4X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding: ${s.LayoutTokens.space["6X"].value};
  }
  ${({listGroupId:e})=>a.css`
    #${e} {
      > div:first-of-type {
        > div:first-of-type {
          padding-top: ${s.LayoutTokens.space["4X"].value};
          @media (min-width: ${p.breakpoints.tabletSmall.min}) {
            padding-bottom: ${s.LayoutTokens.space["6X"].value};
          }
        }
      }
      @media (min-width: ${p.breakpoints.tabletSmall.min}) {
        > div:not(:first-of-type) {
          > div:first-of-type {
            padding-top: ${s.LayoutTokens.space["6X"].value};
            padding-bottom: ${s.LayoutTokens.space["6X"].value};
          }
        }
        > div:last-of-type {
          > div:first-of-type {
            padding-bottom: 0;
          }
        }
      }
    }
  `}
`,y=c.default.div.withConfig({displayName:"LineAttribute",componentId:"VDS__sc-fyj8f3-2"})`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-bottom: ${s.LayoutTokens.space["2X"].value};
  width: 100%;
  @media (max-width: ${p.breakpoints.mobileLarge.max}) {
    padding-top: ${s.LayoutTokens.space["2X"].value};
  }
`,b=c.default.div.withConfig({displayName:"TextLinkWrapper",componentId:"VDS__sc-fyj8f3-3"})`
  padding-left: ${s.LayoutTokens.space["3X"].value};
`,g=c.default.div.withConfig({displayName:"TitleLockupWrapper",componentId:"VDS__sc-fyj8f3-4"})`
  padding-top: ${s.LayoutTokens.space["2X"].value};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`,j=c.default.div.withConfig({displayName:"ListGroupItemWrapper",componentId:"VDS__sc-fyj8f3-5"})`
  display: flex;
  flex-direction: column;
  width: 100%;
`,v=c.default.div.withConfig({displayName:"ListItemButtonGroupWrapper",componentId:"VDS__sc-fyj8f3-6"})`
  display: flex;
  > div {
    display: flex;
    justify-content: space-between;
    > div {
      padding-bottom: 0;
      padding-top: 0;
    }
    > div:last-of-type {
      padding-right: 0;
    }
  }
  padding-top: ${s.LayoutTokens.space["2X"].value};
  width: 100%;

  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding-top: ${s.LayoutTokens.space["4X"].value};
  }
`,x=c.default.span.withConfig({displayName:"SubtitleWrapper",componentId:"VDS__sc-fyj8f3-7"})`
  padding-top: ${s.LayoutTokens.space["2X"].value};
`,k=c.default.div.withConfig({displayName:"ButtonGroupWrapperMobile",componentId:"VDS__sc-fyj8f3-8"})`
  > div {
    > div {
      padding-bottom: ${s.LayoutTokens.space["2X"].value};
    }
  }
  padding-top: ${({paddingTop:e})=>e};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,h=c.default.div.withConfig({displayName:"ButtonGroupWrapperDesktop",componentId:"VDS__sc-fyj8f3-9"})`
  > div {
    > div {
      padding-bottom: 0;
      > button {
        padding-left: ${s.LayoutTokens.space["6X"].value};
        padding-right: ${s.LayoutTokens.space["6X"].value};
      }
    }
  }
  padding-left: ${s.LayoutTokens.space["6X"].value};
  @media (max-width: ${p.breakpoints.mobileLarge.max}) {
    display: none;
  }
`;exports.default=a=>{const{line:p,title:r,subtitle:u,list:c,buttonGroup:L,elementSurface:$="light"}=a,T=e.__rest(a,["line","title","subtitle","list","buttonGroup","elementSurface"]),_=c&&c.id?c.id:"tradeInList";return t.jsx(m,Object.assign({padding:"0px",borderRadius:"8px",height:"auto"},T,{children:t.jsxs(f,Object.assign({listGroupId:_},{children:[p&&c&&t.jsxs(y,{children:[p.title&&t.jsx(d.Body,Object.assign({color:s.ColorTokens.elements.secondary[`on${$}`].value,size:"large"},p.title)),p.textLink&&t.jsx(b,{children:t.jsx(n.TextLink,Object.assign({size:"small",surface:$},p.textLink,{type:"standAlone"}))})]}),(r||u)&&t.jsxs(g,{children:[t.jsxs(l.TitleLockup,Object.assign({surface:$},{children:[r&&t.jsx(l.TitleLockupTitle,Object.assign({size:"titleMedium"},r)),u&&c&&t.jsx(l.TitleLockupSubtitle,Object.assign({size:"bodyLarge"},u))]})),L&&t.jsx(h,{children:t.jsx(n.ButtonGroup,Object.assign({surface:$},L))})]}),c&&(c?t.jsx(o.ListGroup,Object.assign({surface:$,bottomLine:!1},c,{data:void 0,id:_},{children:c.data&&c.data.map(((e,a)=>i.createElement(o.ListGroupItem,Object.assign({},e,{key:`List-item-${a}`,custom:!0}),t.jsxs(j,{children:[e.title&&t.jsx(d.Body,Object.assign({size:"large",bold:!1,color:s.ColorTokens.elements.primary[`on${$}`].value},e.title)),e.subtitle&&t.jsx(x,{children:t.jsx(d.Body,Object.assign({size:"medium",color:s.ColorTokens.elements.primary[`on${$}`].value},e.subtitle))}),e.buttonGroup&&t.jsx(v,{children:t.jsx(n.ButtonGroup,Object.assign({surface:$},e.buttonGroup))})]}))))})):null),L&&t.jsx(k,Object.assign({paddingTop:c?0:s.LayoutTokens.space["6X"].value},{children:t.jsx(n.ButtonGroup,Object.assign({surface:$},L))}))]}))}))};
